import React, { useState, useEffect } from 'react';
import partnerService from '../services/partnerService';
import CountrySelect from './CountrySelect';
import CurrencySelect from './CurrencySelect';

const PartnerDetailsTab = ({ partnerId }) => {
    const [formData, setFormData] = useState({
        companyname: '',
        email: '',
        phone: '',
        mobile: '',
        country: '',
        currency: 'EUR',
    });
    const [loading, setLoading]   = useState(true);
    const [saving, setSaving]     = useState(false);
    const [error, setError]       = useState(null);
    const [savedMsg, setSavedMsg] = useState(null);

    useEffect(() => {
        if (!partnerId) return;
        setLoading(true);
        partnerService.getPartnerById(partnerId)
            .then(res => {
                const p = res.data?.partner || res.partner || res.data || {};
                setFormData({
                    companyname: p.companyname || '',
                    email:       p.email       || '',
                    phone:       p.phone       || '',
                    mobile:      p.mobile      || '',
                    country:     p.country     || '',
                    currency:    p.currency    || 'EUR',
                });
            })
            .catch(err => setError(err.response?.data?.message || 'Failed to load partner'))
            .finally(() => setLoading(false));
    }, [partnerId]);

    const handleChange = (e) => setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.companyname.trim()) { setError('Company Name is required'); return; }
        setSaving(true);
        setError(null);
        setSavedMsg(null);
        try {
            await partnerService.updatePartner(partnerId, formData);
            setSavedMsg('Saved.');
            setTimeout(() => setSavedMsg(null), 3000);
        } catch (err) {
            setError(err.response?.data?.message || err.message || 'Failed to save');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div style={{ padding: '1rem', color: '#6b7280' }}>Loading…</div>;

    return (
        <form onSubmit={handleSubmit} className="partner-form">
            {error && <div className="error-message" style={{ marginBottom: '1rem' }}>{error}</div>}
            {savedMsg && <div style={{ marginBottom: '1rem', padding: '0.5rem 0.75rem', background: '#ecfdf5', border: '1px solid #6ee7b7', borderRadius: '6px', color: '#065f46' }}>{savedMsg}</div>}
            <div className="form-row">
                <div className="form-group">
                    <label>Company Name <span className="required">*</span></label>
                    <input type="text" name="companyname" value={formData.companyname} onChange={handleChange} required />
                </div>
                <div className="form-group">
                    <label>Email</label>
                    <input type="email" name="email" value={formData.email} onChange={handleChange} />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Phone</label>
                    <input type="text" name="phone" value={formData.phone} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Mobile</label>
                    <input type="text" name="mobile" value={formData.mobile} onChange={handleChange} />
                </div>
            </div>
            <div className="form-row">
                <div className="form-group">
                    <label>Country</label>
                    <CountrySelect name="country" value={formData.country} onChange={handleChange} />
                </div>
                <div className="form-group">
                    <label>Currency</label>
                    <CurrencySelect name="currency" value={formData.currency} onChange={handleChange} />
                </div>
            </div>
            <div style={{ marginTop: '1rem' }}>
                <button type="submit" className="btn-primary" disabled={saving}>{saving ? 'Saving…' : 'Save'}</button>
            </div>
        </form>
    );
};

export default PartnerDetailsTab;
